import * as yup from 'yup';

export const transferAccountConfirmNumberValidation = yup.object().shape({
  accountNumber: yup.string().required('Please, enter an account number'),
});
